import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';

import { SuggestionBarActionTypes } from '../constants';

export const Actions = {
  show: () => createAction(SuggestionBarActionTypes.SHOW_SUGGESTION_BAR),
  hide: () => createAction(SuggestionBarActionTypes.HIDE_SUGGESTION_BAR),
};

export type Actions = ActionsUnion<typeof Actions>;
